import { applyOrganizationContext } from '@/services/applyOrganizationContext';
import { trpc } from '@/services/trpc';
import { useBoundStore } from '@/store/store';

export function useOrganizationMutation() {
  const utils = trpc.useUtils();
  const create = trpc.organizations.create.useMutation({
    onSuccess: async data => {
      await applyOrganizationContext({
        access: data.access,
        organizationId: data.user.currentOrganizationId,
        destination: `/organizations/${data.organization.id}/edit`,
      });
    },
  });

  const update = trpc.organizations.update.useMutation({
    onSuccess: async (data, { id }) => {
      await Promise.all([
        ...(id === useBoundStore.getState().currentOrganizationId
          ? [utils.organizations.getCurrent.invalidate()]
          : []),
        utils.organizations.findAll.invalidate(),
        utils.organizations.findOne.invalidate({ id }),
        utils.chats.findOne.invalidate(),
      ]);
    },
  });

  const remove = trpc.organizations.delete.useMutation({
    onSuccess: async data => {
      await applyOrganizationContext({
        access: data.access,
        organizationId: data.user.currentOrganizationId,
        destination: '/organizations',
      });
    },
  });

  return {
    create,
    update,
    remove,
  };
}
